export default (options = {}) => {
  const defaults = {
    id: "subscribeModal",
    scrollOffset: 800,
    mobileViewBreakpoint: 800,
    localStorageKey: "subscribeModalDisplayed",
    addScrollHandler: true,
  };
  const config = { ...defaults, ...options };
  const getTargetNode = () => document.getElementById("subscribeModal");

  function openModal() {
    const button = document.querySelector('[data-action="click->subscribe#toggle"]');

    button.click();
  }

  function onModalOpened() {
    const modal = getTargetNode();

    openModal();
    modal.querySelector("form input[name='email']")?.focus();
    localStorage.setItem(config.localStorageKey, true);
    window.removeEventListener("scroll", subscribeModalScrollHandler);
  }

  function subscribeModalScrollHandler() {
    const modal = getTargetNode();
    const scrollOffset = modal.dataset.scrollOffset || config.scrollOffset;

    if (!modal.classList.contains("is-opened") && window.scrollY > scrollOffset) {
      onModalOpened();
    }
  }

  if (config.addScrollHandler && !localStorage.getItem(config.localStorageKey)) {
    window.addEventListener("scroll", subscribeModalScrollHandler);
  }
};
